export default __webpack_public_path__ + "static/media/ico-ads-sell.e3519cca.webp";